const items = [
  "Free trial lessons",
  "Taught at your own pool",
  "Residents save 15%",
  "Coach Abrie & her team",
  "Ages 1–12",
  "Fall mini session · now enrolling",
];

const Track = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="mx-8 whitespace-nowrap font-serif italic text-lg sm:text-xl text-[#f8f3e9]/90">
          {t}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-[#c97049]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="marquee-band">
      <div className="overflow-hidden bg-[#00334a] py-4">
        <div className="marquee-track flex w-max">
          <Track hidden={false} />
          <Track hidden={true} />
        </div>
      </div>
      <div className="overflow-hidden bg-[#f8f3e9]" aria-hidden="true">
        <svg
          className="wave-drift block h-10 w-[115%] text-[#00334a]"
          viewBox="0 0 1440 40"
          preserveAspectRatio="none"
          fill="currentColor"
        >
          <path d="M0 0 H1440 V14 Q1380 38 1320 14 T1200 14 T1080 14 T960 14 T840 14 T720 14 T600 14 T480 14 T360 14 T240 14 T120 14 T0 14 Z" />
        </svg>
      </div>
    </div>
  );
}
